import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppContextAction, CoreUiInteractionEvent, ProductType, UiInteractionAction } from "@obg/ngx.core";
import { CoreContentState, MenuItem, MenuSelector } from "@obg/ngx.core.content";
import { ignoreEmpty, isExternalUrl } from "@obg/ngx.global";
import { RouteAction, RouteLinkActiveOptions, RouteLinkService, RouterState, RouteSelector } from "@obg/ngx.router";
import { map } from "rxjs/operators";

import { TrackingContext } from "../tracking/tracking.model";

@Component({
	selector: "obg-product-selector-container",
	templateUrl: "./product-selector.container.html",
	styleUrls: ["./product-selector.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ProductSelectorContainer implements OnChanges, OnDestroy {
	@HostBinding("class.obg-product-selector") hostCssClass = true;
	@HostBinding("attr.data-variant") @Input() variant: "primary" | "secondary" = "primary";
	@Input() trackingContext = TrackingContext.ProductSelectorInteractionContext;
	@Output() itemClick = new EventEmitter();
	linkActiveOptions: RouteLinkActiveOptions = { urlsToMatchFrom: [] };
	menuItems: MenuItem[] = [];

	readonly productMenu$ = this.store
		.select(MenuSelector.get("product-menu"))
		.pipe(
			map((menu) => menu?.items),
			ignoreEmpty()
		)
		.subscribe((response) => {
			this.menuItems = response;
		});

	private currentRouteName = "";
	private currentRouteSubscription$$ = this.store
		.pipe(RouteSelector.getCurrent$)
		.subscribe((current) => (this.currentRouteName = current.name));

	constructor(
		private store: Store<RouterState | CoreContentState>,
		private routeLinkService: RouteLinkService,
		private uiInteractionAction: UiInteractionAction,
		private appContextAction: AppContextAction
	) {}

	ngOnChanges() {
		this.linkActiveOptions = {
			urlsToMatchFrom: this.menuItems
				.map((item) =>
					this.routeLinkService.getExternalUrlFromRouteLink({
						url: item.link?.url,
						route: item.route,
					})
				)
				.filter((url) => url !== undefined) as string[],
		};
	}

	ngOnDestroy() {
		this.currentRouteSubscription$$.unsubscribe();
	}

	isCurrentRoute(item: MenuItem): boolean {
		return this.currentRouteName === (item.route || item.key.split(".")[1]);
	}

	lobbyTrackBy(_index: number, lobby: MenuItem): string {
		return lobby.key;
	}

	onItemClick(item: MenuItem) {
		this.itemClick.emit();
		this.store.dispatch(
			this.uiInteractionAction.emit({
				context: this.trackingContext,
				event: CoreUiInteractionEvent.LobbyChange,
				data: { ItemClicked: item.key },
			})
		);
		if (item.link?.url && isExternalUrl(item.link.url)) {
			this.store.dispatch(this.appContextAction.setProduct(ProductType.Common));
		}
		this.store.dispatch(RouteAction.setDataForSubArea({ subArea: "Product Lobby Page" }));
	}
}
